export default class Subscriber {
    constructor(Rest, Statistics) {
        this.rest = Rest.rest;
        this.statisticRepo = Statistics;
    }

    find(id) {
        return this.rest.one('subscriber').one(id).get();
    };

    search(email, page, view, attributes) {
        return this.rest.one('subscriber').one('search', email).get({
            page: page || 1,
            view: view || 'cards'
        });
    };

    customFields(subscriberId) {
        return this.rest.one('subscriber', subscriberId).one('custom-fields').get();
    };

    all(page) {
        return this.rest.one('subscriber').get({page: page || 1});
    };

    allByStatus(attributes, page, view) {
        return this.rest.one('subscriber').get({
            status: attributes.status,
            page: page || 1,
            view: view || 'cards'
        });
    };

    store(attributes) {
        return this.rest.all('subscriber').post(attributes);
    };

    update(id, attributes) {
        return this.rest.one('subscriber', id).customPUT(attributes);
    };

    import(data) {
        return this.rest.all('import').post(data);
    };

    getImportProgress() {
        return this.rest.one('import').one('progress').get();
    };

    stopImport(id) {
        return this.rest.one('import/' + id + '/stop').post();
    };

    uploadImportFile(file) {
        var importFile = new FormData();
        importFile.append(file.name, file);

        return this.rest.one('import/upload').withHttpConfig({transformRequest: angular.identity}).customPOST(
            importFile,
            '',
            {},
            {'Content-Type': undefined}
        );
    };

    uploadCopyPaste(copyPaste) {
        return this.rest.all('import/copy-paste').post({content: copyPaste});
    };

    tags(id) {
        return this.rest.one('subscriber').one(id).one('tags').get();
    };

    segmentations(id) {
        return this.rest.one('subscriber').one(id).one('segmentations').get();
    };

    bounces(id) {
        return this.rest.one('subscriber').one(id).one('bounces').get();
    };

    suppressions(id) {
        return this.rest.one('subscriber').one(id).one('suppressions').get();
    };

    removeTag(id, tagId) {
        return this.rest.one('subscriber', id).one('tags', tagId).remove();
    };

    delete(id) {
        return this.rest.one('subscriber', id).remove();
    };

    massDelete(subscribers) {
        return this.rest.one('subscriber').customOperation('remove', null, {}, {'Content-Type': 'application/json'}, {'subscribers': subscribers});
    };

    suppress(id, suppressOn) {
        return this.rest.one('subscriber', id).one('suppress').customPUT({suppress_on: suppressOn});
    };

    activity(id, page, search) {
        return this.rest.one('subscriber', id).one('activity').get({
            page: page || 1,
            query: search || null
        });
    };

    addTag(id, tag) {
        return this.rest.all('subscriber/' + id + '/tag').post({tag: tag});
    };

    massAddTags(subscribers, tags) {
        return this.rest.all('subscriber/tags').post({subscribers: subscribers, tags: tags});
    }

    statusCount() {
        return this.rest.one('subscriber').one('statusCount').get();
    };

    setLanguage(id, language) {
        return this.rest.one('subscriber', id).one('language').customPUT({language_id: language});
    };

    getImportReport(importId) {
        return this.rest.one('import', importId).one('report').get();
    };

    getFailedRows(importId, page, partial) {
        return this.rest.one('import', importId).one('failed-rows').get({
            page: page,
            partial: partial
        });
    };

    newSubscribersByDate(interval) {
        var dates = {startDate: null, endDate: null};

        if (interval) {
            dates = this.statisticRepo.formatUTCDates(interval.startDate, interval.endDate);
        }

        return this.rest.one('subscriber').one('statistics').get({startDate: dates.startDate, endDate: dates.endDate});
    };

    resubscribe(id) {
        return this.rest.one('subscriber', id).one('suppress').remove();
    };
};